import React, { useRef } from "react";
import { Link } from "react-router-dom";
import "./ComponenteCSS/Hero.css";
import { ChevronDown } from "lucide-react";

const Hero = () => {
  const h4Ref = useRef(null);
  // const [isVisible, setIsVisible] = useState(false);

  // useEffect(() => {
  //   const currentRef = h4Ref.current;

  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           setIsVisible(true);
  //         } else {
  //           setIsVisible(false);
  //         }
  //       });
  //     },
  //     {
  //       threshold: 0.5,
  //       rootMargin: "0px",
  //     }
  //   );

  //   if (currentRef) {
  //     observer.observe(currentRef);
  //   }

  //   return () => {
  //     if (currentRef) {
  //       observer.unobserve(currentRef);
  //     }
  //     observer.disconnect(); // Adicionando disconnect para limpar os observadores
  //   };
  // }, []); // Removendo h4Ref como dependência

  return (
    <section id="Hero">
      <div className="hero-wrapper">
        <div className="hero-above">
          <h4 ref={h4Ref} className="Headline">
            Soluções jurídicas estratégicas para o agronegócio
          </h4>
        </div>
        <div className="hero-area-atuaçao">
          <Link to="/areas/renegociacao-dividas" className="area-link">
            <div className="area">
              <ChevronDown className="icon" strokeWidth={1.5} />
              <p>RENEGOCIAÇÃO DE DÍVIDAS RURAIS</p>
            </div>
          </Link>
          <Link to="/areas/defesa-execucoes" className="area-link">
            <div className="area">
              <ChevronDown className="icon" strokeWidth={1.5} />
              <p>DEFESA EM EXECUÇÕES JUDICIAIS E EXTRAJUDICIAIS</p>
            </div>
          </Link>
          <Link to="/areas/impenhorabilidade" className="area-link">
            <div className="area">
              <ChevronDown className="icon" strokeWidth={1.5} />
              <p>IMPENHORABILIDADE DE TERRAS E IMPLEMENTOS RURAIS</p>
            </div>
          </Link>
          <Link to="/areas/seguro-rural" className="area-link">
            <div className="area">
              <ChevronDown className="icon" strokeWidth={1.5} />
              <p>SEGURO RURAL E PROAGRO</p>
            </div>
          </Link>
          <Link to="/areas/indenizacao-perdas" className="area-link">
            <div className="area">
              <ChevronDown className="icon" strokeWidth={1.5} />
              <p>INDENIZAÇÃO POR PERDAS E DANOS EM EXECUÇÕES RURAIS</p>
            </div>
          </Link>
          <Link to="/areas/revisao-juros" className="area-link">
            <div className="area">
              <ChevronDown className="icon" strokeWidth={1.5} />
              <p>REVISÃO DE JUROS E ENCARGOS NO CRÉDITO RURAL</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
